import { ViewConfig } from "../../../components"
import { readViewRequestForm, deleteViewRequestForm, editViewRequestForm, searchViewRequestForm, newViewRequestForm,
  readViewStatus, searchViewStatus, editViewStatus, newViewStatus, deleteViewStatus } from "../../../components/Forms"
import { validators } from "react-ocean-forms"
import { ViewMode } from "../../../components/Common/ViewMode"
import { customvalidators } from "../../../utils"


export const searchView: ViewConfig = {

  viewName: ViewMode.Search,
  fields: {
    component_name: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        validators: [customvalidators.typeRequired],
      },
    },
    code: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        //@ts-ignore
        validators: [validators.withParam(validators.maxLength, 8)],
      },
    },

    name: {
      field: {
        disabled: false,
        hidden: true,
        plaintext: false,
        //@ts-ignore
        validators: [validators.withParam(validators.maxLength, 1024)],
      },
    },
    names: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    annotations: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        //@ts-ignore
        validators: [validators.withParam(validators.maxLength, 150)],
      },
    },
    casnumber: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    sumformula: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    eunumber: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    alternativname: {
      field: {
        disabled: true,
        hidden: true,
        plaintext: false,
      },
    },
    symbol: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        //@ts-ignore
        validators: [validators.withParam(validators.maxLength, 20)],
      },
    },
    iso_code: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        //@ts-ignore
        validators: [validators.withParam(validators.maxLength, 15)],
      },
    },
    dimension: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    titel: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        //@ts-ignore
        validators: [validators.withParam(validators.maxLength, 1024)],
      },
    },
    valid_from: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    ...searchViewRequestForm,
    ...searchViewStatus,
  }
}

export const deleteView: ViewConfig = {
  viewName: ViewMode.Delete,
  fields: {
    component_name: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },
    code: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },

    name: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },
    names: {
      field: {
        disabled: true,
        hidden: true,
        plaintext: false,
      },
    },
    annotations: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },
    casnumber: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },
    sumformula: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },
    eunumber: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },
    alternativname: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },
    symbol: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },
    dimension: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },
    iso_code: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },
    titel: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },
    valid_from: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },
    ...deleteViewRequestForm,
    ...deleteViewStatus,

  }
}

export const readView: ViewConfig = {
  viewName: ViewMode.Read,
  fields: {
    component_name: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: true,
      },
    },
    code: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: true,
      },
    },
    name: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: true,
      },
    },
    names: {
      field: {
        disabled: true,
        hidden: true,
        plaintext: false,
      },
    },
    annotations: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: true,
      },
    },
    casnumber: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: true,
      },
    },
    sumformula: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: true,
      },
    },
    eunumber: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: true,
      },
    },
    alternativname: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: true,
      },
    },
    symbol: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: true,
      },
    },
    dimension: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: true,
      },
    },
    iso_code: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: true,
      },
    },
    titel: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: true,
      },
    },
    valid_from: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: true,
      },
    },
    ...readViewRequestForm,
    ...readViewStatus
  }
}



export const editView: ViewConfig = {
  viewName: ViewMode.Edit,
  fields: {
    component_name: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },
    code: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },

    name: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        //@ts-ignore
        validators: [validators.required, validators.withParam(validators.maxLength, 1024)],
      },
    },
    names: {
      field: {
        disabled: true,
        hidden: true,
        plaintext: false,
      },
    },
    annotations: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        //@ts-ignore
        validators: [validators.withParam(validators.maxLength, 150)],
      },
    },
    casnumber: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        //@ts-ignore
        validators: [validators.withParam(validators.maxLength, 20)],
      },
    },
    sumformula: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        //@ts-ignore
        validators: [validators.withParam(validators.maxLength, 40)],
      },
    },
    eunumber: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        //@ts-ignore
        validators: [validators.withParam(validators.maxLength, 20)],
      },
    },
    alternativname: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    symbol: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        //@ts-ignore
        validators: [validators.withParam(validators.maxLength, 20)],
      },
    },
    dimension: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        validators: [validators.required],
      },
    },
    iso_code: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        //@ts-ignore
        validators: [validators.withParam(validators.maxLength, 15)],
      },
    },
    titel: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        //@ts-ignore
        validators: [validators.required, validators.withParam(validators.maxLength, 1024)],
      },
    },
    valid_from: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        validators: [validators.required],
      },
    },
    ...editViewRequestForm,
    ...editViewStatus,
  }
}

export const newView: ViewConfig = {
  viewName: ViewMode.New,
  fields: {
    component_name: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    code: {
      field: {
        disabled: true,
        hidden: false,
        plaintext: false,
      },
    },

    name: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        //@ts-ignore
        validators: [validators.required, validators.withParam(validators.maxLength, 1024)],
      },
    },
    annotations: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        //@ts-ignore
        validators: [validators.withParam(validators.maxLength, 150)],
      },
    },
    names: {
      field: {
        disabled: true,
        hidden: true,
        plaintext: false,
      },
    },
    casnumber: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        //@ts-ignore
        validators: [validators.withParam(validators.maxLength, 20)],
      },
    },
    sumformula: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        //@ts-ignore
        validators: [validators.withParam(validators.maxLength, 40)],
      },
    },
    eunumber: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        //@ts-ignore
        validators: [validators.withParam(validators.maxLength, 20)],
      },
    },
    alternativname: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
      },
    },
    symbol: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        //@ts-ignore
        validators: [validators.withParam(validators.maxLength, 20)],
      },
    },
    dimension: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        validators: [validators.required],
      },
    },
    iso_code: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        //@ts-ignore
        validators: [validators.withParam(validators.maxLength, 15)],
      },
    },
    titel: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        //@ts-ignore
        validators: [validators.required, validators.withParam(validators.maxLength, 1024)],
      },
    },
    valid_from: {
      field: {
        disabled: false,
        hidden: false,
        plaintext: false,
        validators: [validators.required],
      },
    },
    ...newViewRequestForm,
    ...newViewStatus
  }
}
